import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { MySequencesContent } from '@/components/user/MySequencesContent';

const MySequences = () => {
  return (
    <>
      <Helmet>
        <title>My Sequences - LightsHunt</title>
        <meta name="description" content="Manage your uploaded light sequences. View analytics, download stats, and edit your sequence details." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <NavBar />
        <main className="pt-20">
          <MySequencesContent />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default MySequences;